<template>
  <ValidationObserver ref="addFileToOfferGroupForm">
    <Dialog :data="dialogSettings">
      <div class="mt-5">
        <ValidationProvider v-slot="{ errors }" name="name" rules="required">
          <v-label>Name</v-label>
          <v-text-field
            class="offer-file-input"
            aria-label="Name"
            v-model="name"
            :error-messages="getErrorMessages(errors)"
          />
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="description"
          rules="required"
        >
          <v-label>Description</v-label>
          <v-textarea
            :error-messages="getErrorMessages(errors)"
            v-model="description"
            class="offer-file-input"
          />
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="documentType"
          rules="required"
        >
          <v-label>Form Type</v-label>
          <Select
            v-model="documentType"
            label=""
            :items="documentTypes"
            :error-messages="getErrorMessages(errors)"
            item-text="label"
            item-value="value"
          />
        </ValidationProvider>
        <FileUpload
          class="mt-5"
          @unselectFile="unselectFile"
          @selectFile="selectFile"
          :files="files"
          :fileTypes="['application/pdf']"
          showPreview
          @show="showFile"
          disableAutoProceed
          customActions
          :showValidationErrors="showValidationErrors"
        />
        <PDFViewFull :data="fileDialog" />
      </div>
      <template v-slot:dialog.actions>
        <PrimaryButton @click.native="close" text>Cancel</PrimaryButton>
        <PrimaryButton
          @click.native="onSubmit"
          :loading="isAddingFileToOfferGroup"
        >
          Save File
        </PrimaryButton>
      </template>
    </Dialog>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import Dialog from "@/components/common/Dialog";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { getFilePreviewSettings } from "@/utils/files";
import PDFViewFull from "@/components/common/PDFViewFull";
import Select from "@/components/common/Select";
import FileUpload from "@/components/common/FileUpload";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { ADD_FILE_TO_OFFER_GROUP } from "@/store/modules/offers/actions";
import { filter, first } from "lodash";
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapState } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  name: "AddFileToOfferGroupDialog",
  components: {
    Dialog,
    PrimaryButton,
    ValidationObserver,
    ValidationProvider,
    PDFViewFull,
    FileUpload,
    Select
  },
  props: {
    offerGroupId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      files: [],
      documentType: null,
      description: "",
      name: "",
      showValidationErrors: false,
      dialogSettings: {
        dialog: true,
        title: "Add file"
      },
      fileDialog: { dialog: false },
      documentTypes: [
        {
          label: "Form",
          value: "fillable"
        },
        {
          label: "Reference Document",
          value: "information"
        }
      ]
    };
  },
  computed: {
    ...mapState(["isAddingFileToOfferGroup"]),
    currentOfferId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions({
      addFileToOfferGroup: ADD_FILE_TO_OFFER_GROUP
    }),
    close() {
      this.$emit("close");
    },
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    },
    async showFile(file) {
      const filePreviewSettings = await getFilePreviewSettings(file);
      this.fileDialog = {
        ...filePreviewSettings,
        dialog: true
      };
    },
    selectFile({ file }) {
      this.files.push(file);
    },
    unselectFile({ uppyInstance, file: fileToBeRemoved }) {
      this.files = filter(this.files, file => file.id !== fileToBeRemoved.id);
      uppyInstance.reset();
    },
    getNewDocumentData() {
      const formData = new FormData();
      formData.append("file", first(this.files).data);
      formData.append("documentType", this.documentType);
      formData.append("description", this.description);
      formData.append("name", this.name);

      return formData;
    },
    async onSubmit() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.addFileToOfferGroupForm.validate();
      if (isValid) {
        await this.addFileToOfferGroup({
          offerGroupId: this.offerGroupId,
          offerId: this.currentOfferId,
          data: this.getNewDocumentData()
        });
        this.close();
      }
    }
  }
};
</script>

<style lang="scss">
.offer-file-input {
  &.v-input.v-text-field {
    margin-top: 0px;
  }
}
</style>
